<template>
<div id="fiberglass" class="w-100 tc black pb4">
    <div class="container w-100">
      
      <div class="relative dt w-100" :style="{ 'height': mobile ? '45vh': '80vh'}">
        <!-- <img class="w-100 banner dtc v-mid" src="https://d3fgmcoixbear.cloudfront.net/s3fs-public/sustainable%20insulation_6.jpg"/> -->
        <div class="w-100 b ph2 tc dtc white v-mid">
          <div class="f1">Rigid Board Insulation </div>
          <!-- <div class="f2-ns f3 mt2">Batt & Blown Insulation</div> -->
        </div>
      </div>

      <div class="w-100-ns center tc">

        <div class="w-40-ns w-90 fl-ns tc center">
          <div class="pa3 dib tc center w-100"><img class="w-50-ns w-80" src="../assets/cejmlogo.png"/></div>
          <div class="dt w-100">
            <div class="pa3-ns pv5"><img class="w-70" src="../assets/jmrigid.png"/></div>
          </div>
        </div>

        <div class="w-30-ns w-80 fl-ns tc center">
          <div class="pt3 dib tc center w-100"><img class="w-30-ns w-50" src="https://images.squarespace-cdn.com/content/v1/57a39be0579fb3a3a8540f56/1517864369261-MSBVNTC1WSJJTZQ9DJ8N/ke17ZwdGBToddI8pDm48kJFDWLSgtICDRU8V8A7NpDoUqsxRUqqbr1mOJYKfIPR7LoDQ9mXPOjoJoqy81S2I8N_N4V1vUb5AoIIIbLZhVYxCRW4BPu10St3TBAUQYVKcMdIiSJY1uuJq-XdLo7Lcjn7Fpb4d1XUIHjryifPJUS5RWSLKCtL6bLHjvarWr2j3/Rmax+Logo+-+USE.png"/></div>
          <div class="w-100">
            <div class="pa3-ns pv5"><img class="" src="../assets/rmax.png"/></div>
          </div>
        </div>

        <div class="w-30-ns w-100 fl-ns tc center">
          <div class="pt3 dib tc center w-100"><img class="w-30-ns w-50" src="../assets/logos-color/atlas.png"/></div>
          <div class=" w-100">
            <div class="pa3-ns pv5"><img class="w-90" src="../assets/es.png"/></div>
          </div>
        </div>

      </div>

      <div class="w-60-ns w-100 center">

        <div class="pt4" :class="[mobile ? 'w-90 dib' : 'w-50 lh-copy f4 dtc v-mid']">
          <div class="tl t4 bullets">
            <h3 @click="expand1 = !expand1"><span class="mt2 f3" v-if="!expand1">+</span><span v-else class="mt2 f3">-</span> USE RIGID BOARD INSULATION</h3>
            <transition name="fade">
              <div v-if="expand1" class="">Polyisocyanurate (Polyiso) is a closed-cell, rigid foam board insulation that is bonded to facers on both sides, which are composed of various organic and inorganic materials. Polyiso is used in roof, wall, ceiling and specialty applications within commercial and residential buildings of all types. Because of its high thermal performance, it is the product of choice for energy-aware architects, specifiers, builders, building owners, contractors and consumers.</div>
            </transition>
            <h3 @click="expand2 = !expand2"><span class="mt2 f3" v-if="!expand2">+</span><span v-else class="mt2 f3">-</span> WHERE TO USE RIGID BOARD INSULATION</h3>
              <div v-if="expand2" class="">Because of its resistance to moisture, rigid board insulation is a great choice whenever and wherever there is a chance it could get wet, such as: an exterior foundation, inside a basement against the foundation, and on the outside of a house beneath a house wrap. Foam board insulation is more expensive than traditional batt insulation, so use it only when moisture is a factor and  it makes sense with your budget.</div>

            <h3 @click="expand3 = !expand3"><span class="mt2 f3" v-if="!expand3">+</span><span v-else class="mt2 f3">-</span> RIGID BOARD INSULATION R-VALUES</h3>
              <div v-if="expand3" class="">Polyiso – which Forbes considers a “green” insulation – offers the highest R-value in its class, with a 20% - 70% greater R-value per inch than any other rigid foam plastic insulation. </div>
          </div>
        </div>
      </div>
    </div>

      <div class="resources pv5-ns pv3">
        <div class="f3 pb3">Specification Sheets</div>
        <div :class="[mobile ? '' : 'dt w-90 center']">
          <div :class="[mobile ? 'pv3 w-50 center' : 'dib ph1 w-20-ns center']">
            <a class=" spec link ps-blue dtc v-mid" href="https://static1.squarespace.com/static/57a39be0579fb3a3a8540f56/t/6605bdec40418a7679a8e51f/1711652332693/RmaxThermasheath_Product-Data-Sheet_Revision.03-21-2024.pdf" target="_blank">
              <div class="f3">
              <img class="w-20-ns w-20" src="../assets/spec.png"/><br/>
              RMax Insulation 
              </div>
            </a>
          </div>

          <div :class="[mobile ? 'pv3 w-50 center' : 'dib ph1 w-20-ns center']">
            <a class=" spec link ps-blue dtc v-mid" href="https://www.jm.com/content/dam/jm/global/en/building-insulation/Files/BI%20Data%20Sheets/Resi%20and%20Commercial/BID-0151-AP-FoilFaced-DS.pdf" target="_blank">
              <div class="f3">
              <img class="w-20-ns w-20" src="../assets/spec.png"/><br/>
              AP Foil-Faced Foam
              </div>
            </a>
          </div>


          <div :class="[mobile ? 'pv3 w-50 center' : 'dib ph1 w-20-ns center']">
            <a class=" spec link ps-blue dtc v-mid" href="https://wall.atlasrwi.com/wp-content/uploads/sites/2/2023/12/ATL-2104-ES-DataSheet.pdf" target="_blank">
              <div class="f3">
              <img class="w-20-ns w-20" src="../assets/spec.png"/><br/>
              Atlas Energy Shield
              </div>
            </a>
          </div>
          
        </div>
      </div>


      <div class="w-20-ns tc w-70 mt4-ns mt2 center">
        <div class="f3-ns f4 pa1">
            <a class="link" :href="info.tel">
              <div class="contact-button ps-blue b br3 bg-yellow tc pa2 link"><i class="fa fa-phone mr3" style="font-size:20px"/>Call for a quote!<div class="">{{info.phone}}</div></div>
          </a> 
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Denim',
  props: ['info', 'mobile'],
  data() {
    return {
      expand1: false,
      expand2: false,
      expand3: false,
    };
  },
  methods: {
  },
  components: { 
  }
};
</script>

<style scoped>
.moreless {
  -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
  filter: invert(100%);
}
.spec {
  border: black 1px solid;
  padding: .5rem;
  margin: 0.5rem .5rem;
  border-radius: 2%;
}
.spec:hover{
  background: rgb(15,55,111);
  color: white;
}
.spec:hover img {
    -webkit-filter: invert(1);
}
h3 {
  padding: 1rem;
  border: solid black 1px;
  background: rgb(15,55,111);
  text-align: center;
  color: white;
}
#fiberglass {
  min-height: 85vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url("https://images.unsplash.com/photo-1516541196182-6bdb0516ed27?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80");
  /* background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .7)), url("https://d3fgmcoixbear.cloudfront.net/s3fs-public/sustainable%20insulation_6.jpg");
  background-repeat: no-repeat;
  background-size: cover; */
}
.relative {
  background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .5)), url("https://images.squarespace-cdn.com/content/v1/57a39be0579fb3a3a8540f56/1505847442406-5L1ZG6CZ3SOM0AJYRA7V/ke17ZwdGBToddI8pDm48kJdye1SANJzf6hvSRe7yKKJ7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0hx0TKp4jCW7sB_BGURRbuXnohgab11AaT_oL_DSYmYP9KFiX0qn1K27hpvkzbUH5A/Rmax+Thermasheath-3+-+Nebreska+Furniture+Mart%2C+The+Colony%2C+TX+2-Compressed.jpg");
  background-repeat: no-repeat;
  background-size: cover; 
  background-position: 10% 90%;
}
.banner {
  background-image: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .7));
  max-height: 300px;
}
.absolute {
  top: 10%;
  right: 10%;
}
.rigid {
  max-width: 150px;
}
.sustainable {
  max-height: 100px;
}

.contact-button {
  color: rgb(15,55,111) !important;
}

.contact-button:hover {
  background: rgb(15, 55, 111) !important;
  color: gold !important;
  box-shadow: gold 5px 5px !important;
  transition: .3s ease;
}

.contact-button {
  box-shadow: rgb(15,55,111) 5px 5px !important;
  background:gold 5px 5px !important;
  padding: .7rem !important;
  color: rgb(15, 55, 111) !important;
  transition: .3s ease;
}
.link {
  /* box-shadow: rgb(15,55,111) 3px 3px !important; */
  text-decoration: none;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>